module.exports = __webpack_public_path__ + "static/hero-bus-open-data-package-a7189a5eb51630dd3bc8a12081f208d9.jpg";